import {writable} from "svelte/store";
import type {EmailTemplate} from "$lib/types/EmailTemplate";
export const mailTemplates = writable<EmailTemplate[]>([])